import React, { useState } from 'react'

// Utils
import InputValidation from '../../utils/InputValidation'

// Components
import { Typography, Button, Spinner } from '@telavita-core/react-design-kit'
import { TextInput } from 'components'
import Toast from '../../components/Toast'

const Login = ({ handleLogin, failMessage, title }) => {
  const [password, setPassword] = useState({
    value: '',
    hasError: false,
    message: '',
    isValid: false,
  })

  const [username, setUsername] = useState({
    value: '',
    isValid: false,
    message: '',
  })

  const [loading, setLoading] = useState(false)

  const onPasswordChange = (e) => {
    let passwordValue = e.target.value
    let passwordValidation = new InputValidation(
      passwordValue,
      'password'
    ).validate()

    setPassword({
      ...password,
      value: passwordValue,
      message: passwordValidation.message,
      isValid: passwordValidation.success,
    })
  }

  const onUsernameChange = (e) => {
    let usernameValue = e.target.value
    let usernameValidation = new InputValidation(
      usernameValue,
      'email'
    ).validate()
    setUsername({
      value: usernameValue,
      isValid: usernameValidation.success,
      message: usernameValidation.message,
    })
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    const authData = {
      username: username.value,
      password: password.value,
    }

    setPassword({ ...password, isValid: false })

    await handleLogin(authData)
    setLoading(false)
  }

  return (
    <div className='Login'>
      <form
        className='Login__Form'
        onSubmit={onSubmit}
      >
        {failMessage !== '' ? (
          <div className='Login__Form__Error'>
            <Toast variant='error' icon='Info' message={failMessage}/>
          </div>
        ) : (
          <Typography weight='bold' customClassName='Login__Title'>
            {title}
          </Typography>
        )}

        <TextInput
          autofocus={true}
          disabled={false}
          hasError={username.message}
          messageError={username.isValid ? '' : username.message}
          name='username'
          onInputChange={onUsernameChange}
          placeholder='E-mail'
          required={true}
          type='email'
          value={username.value}
        />

        <TextInput
          autofocus={false}
          disabled={false}
          hasError={password.message}
          isPassword={true}
          messageError={password.isValid ? '' : password.message}
          name='password'
          onInputChange={onPasswordChange}
          placeholder='Senha'
          required={true}
          value={password.value}
        />

        <Button
          disabled={!(password.isValid && username.isValid)}
          variant='contained'
          customClassName='Login__SubmitButton'
        >
          {loading ? (
            <Spinner customClassName='Login__Spinner'/>
          ) : 'ENTRAR'}
        </Button>
      </form>
    </div>
  )
}

export default Login
